<!--
PaperPostcard
纸质明信片
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌 > 纸质明信片" name="纸质明信片">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="paperPostcard" label-width="80px">
              <el-form-item label="纸质">
                <el-select v-model="paperPostcard['纸质']" placeholder="纸质">
                  <el-option label="冰白珠光" value="冰白珠光"></el-option>
                  <el-option label="英国白卡" value="英国白卡"></el-option>
                  <el-option label="铜版纸" value="铜版纸"></el-option>
                  <el-option label="亚粉纸" value="亚粉纸"></el-option>
                  <el-option label="星河纸" value="星河纸"></el-option>
                  <el-option label="超感纸" value="超感纸"></el-option>
                  <el-option label="高阶映画" value="高阶映画"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="形状">
                <el-select v-model="paperPostcard['形状']" placeholder="形状">
                  <el-option label="尖角" value="尖角"></el-option>
                  <el-option label="圆角" value="圆角"></el-option>
                  <el-option label="非矩形（异形切膜）" value="非矩形（异形切膜）"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="覆膜">
                <el-select v-model="paperPostcard['覆膜']" placeholder="覆膜">
                  <el-option label="亮膜" value="亮膜"></el-option>
                  <el-option label="亚膜" value="亚膜"></el-option>
                  <el-option label="触感膜" value="触感膜"></el-option>
                  <el-option label="不覆膜" value="不覆膜"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-select v-model="paperPostcard['工艺']" placeholder="请选择制作工艺">
                  <el-option value="烫亮金" label="烫亮金"  name="type"></el-option>
                  <el-option value="烫哑金" label="烫哑金" name="type"></el-option>
                  <el-option value="烫蓝金" label="烫蓝金" name="type"></el-option>
                  <el-option value="烫黑金" label="烫黑金" name="type"></el-option>
                  <el-option value="烫紫金" label="烫紫金" name="type"></el-option>
                  <el-option value="烫银" label="烫银" name="type"></el-option>
                  <el-option value="烫金烫银组合" label="烫金烫银组合" name="type"></el-option>
                  <el-option value="UV" label="UV" name="type"></el-option>
                  <el-option value="镭射" label="镭射" name="type"></el-option>
                  <el-option value="压痕" label="压痕" name="type"></el-option>
                  <el-option value="感温变色" label="感温变色" name="type"></el-option>
                  <el-option value="刷金" label="刷金" name="type"></el-option>
                  <el-option value="刷银" label="刷银" name="type"></el-option>
                  <el-option value="磨砂UV" label="磨砂UV" name="type"></el-option>
                  <el-option value="异形切膜" label="异形切膜" name="type"></el-option>
                  <el-option value="其他" label="其他" name="type"></el-option>
                </el-select>
                <div style="padding:10px"></div>
                <el-alert title="其他工艺请联系客服" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 0 0 0 0;"></el-alert>
              </el-form-item>

              <el-form-item label="尺寸">
                <el-radio-group v-model="paperPostcard['尺寸']">
                  <el-radio-button label="9.8*15cm">9.8*15cm</el-radio-button>
                  <el-radio-button label="自定义尺寸">自定义尺寸</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="自定义尺寸" v-if="paperPostcard['尺寸']=='自定义尺寸'">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="paperPostcard['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="paperPostcard['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="paperPostcard['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="paperPostcard['数量']" :min="500" label="数量"></el-input-number>
                <el-alert
                  title="单款起定数为500"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PaperPostcard",
  data() {
    return {
      forcollapse: ["allsame"],
      paperPostcard: {
        title: "纸质明信片",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.paperPostcard);
    },
    clear() {
      this.$root.clearAlert();
      this.paperPostcard = {
        title: "纸质明信片",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>